// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"add1b39a","703":"09e49af9","729":"3630b1af","787":"55a1d06d"}[chunkId] + ".chunk.js";
};